async function parseJson(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || 'Request failed.');
    error.status = response.status;
    throw error;
  }
  return data;
}

export function checkSession() {
  return fetch('/api/demo/session', { credentials: 'include' }).then(parseJson);
}

export function submitAccessCode(code) {
  return fetch('/api/demo/access', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code })
  }).then(parseJson);
}

export function listDocuments() {
  return fetch('/api/demo/documents', { credentials: 'include' }).then(parseJson);
}

export function uploadDocuments(files) {
  const body = new FormData();
  files.forEach((file) => body.append('files', file));
  return fetch('/api/demo/documents', {
    method: 'POST',
    credentials: 'include',
    body
  }).then(parseJson);
}

export function deleteDocument(id) {
  return fetch(`/api/demo/documents/${id}`, {
    method: 'DELETE',
    credentials: 'include'
  }).then(parseJson);
}

export async function readChatStream(response, { onProgress, onDelta, onMetadata } = {}) {
  if (!response.ok) return parseJson(response);
  if (!response.body || !response.headers.get('content-type')?.includes('text/event-stream')) return parseJson(response);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  try {
    while (true) {
      const { done, value } = await reader.read();
      buffer = (buffer + decoder.decode(value || new Uint8Array(), { stream: !done })).replace(/\r\n/g, '\n');
      let boundary;
      while ((boundary = buffer.indexOf('\n\n')) >= 0) {
        const frame = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        const event = frame.match(/^event: (.+)$/m)?.[1];
        const payload = frame.split('\n').filter((line) => line.startsWith('data: ')).map((line) => line.slice(6)).join('\n');
        if (!event || !payload) continue;
        const data = JSON.parse(payload);
        if (event === 'progress') onProgress?.(data);
        if (event === 'delta') onDelta?.(data.text);
        if (event === 'metadata') onMetadata?.(data);
        if (event === 'answer') return data;
        if (event === 'error') throw new Error(data.message || 'The assistant could not finish this reply.');
      }
      if (done) throw new Error('The connection ended before the answer was complete. Please retry.');
    }
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}

export async function askQuestion(message, history, options = {}) {
  const response = await fetch('/api/demo/chat', {
    method: 'POST',
    credentials: 'include',
    signal: options.signal,
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
    body: JSON.stringify({ message, history, context: options.context })
  });
  return readChatStream(response, options);
}

export function originalFileUrl(id) {
  return `/api/demo/documents/${id}/file`;
}

export function addApprovedLink(title, url) {
  return fetch('/api/demo/links', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ title, url }) }).then(parseJson);
}
export function addApprovedLinks(links) {
  return fetch('/api/demo/links/batch', { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ links }) }).then(parseJson);
}
export function refreshApprovedLink(id) {
  return fetch(`/api/demo/links/${id}/refresh`, { method: 'POST', credentials: 'include' }).then(parseJson);
}
